<p-listbox [options]="values" [(ngModel)]="selectedValues" multiple="multiple" checkbox="checkbox"></p-listbox>
